import CheckedIcon from 'Assets/Images/icons/checked'
import React, { useEffect } from 'react'
import { useFormChildLogic } from '../index'

export const CheckboxUnstyled = ({
  className,
  input = {},
  name,
  initValue,
  // Added for backwards compatibility since this component was updated against SOLID laws
  shouldListenToInputValue,
  customIcon,
  ...others
}) => {
  const { updateForm, value } = useFormChildLogic({
    name,
    initValue: initValue || input.checked || others.checked || input.value,
  })

  useEffect(() => {
    shouldListenToInputValue && updateForm(input.value)
  }, [input])

  const handleClick = e => {
    if (others.onChange) {
      others.onChange(e)
    }
    if (input.onChange) {
      input.onChange(e)
    }
    if (others.onClick) {
      others.onClick(e)
    }
    if (input.onClick) {
      input.onClick(e)
    }

    updateForm(e.target.checked)
  }

  return (
    <div className={className}>
      <div className="checkbox-wrapper">
        <input
          type="checkbox"
          {...input}
          checked={value}
          onClick={handleClick}
          cypress_id={others.cypress_id}
          disabled={input.disabled}
        />
        <CheckedIcon />
      </div>
      <label htmlFor={others.id}>{others.label || ''}</label>
    </div>
  )
}
